import React, { useEffect, useState } from "react";
import { useIds } from "../../hook/AdminContext";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  change_subscription_of_job_alert,
  delete_job_alert,
  get_job_alerts,
} from "../../DAL/jobs/jobs";
import { enqueueSnackbar } from "notistack";
import CircularLoader from "../../components/loader/CircularLoader";
import RecordNoImage from "../../components/recordNotFound/RecordNoImage";
import { Clock, Repeat, ToggleLeft, ToggleRight } from "lucide-react";
import { FormControlLabel, Switch, Tooltip } from "@mui/material";
import CustomPopoverSection from "../../components/menu/MebuCustomPopOverSection";
import CustomConfirmation from "../../components/popUp/CustomConfirmation";
import { convertTimeToServerTimeZone } from "../../utils/Constant";

export default function JobAlerts() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const target_alert = queryParams.get("target_alert");

  console.log(target_alert, "--target alert");

  const { setBreadCrumb, adminSetting } = useIds();
  const { source_slug, jobtype_slug } = useParams();
  const navigate = useNavigate();

  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const [loading, setLoading] = useState(true);
  const [alertList, setAlertsList] = useState([]);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [targetAlert, setTargetAlert] = useState(false);
  const [statusChangeConfirmation, setStatusChangeConfirmation] =
    useState(false);

  const handleNavidateAddAlert = () => {
    navigate(`/${source_slug}/${jobtype_slug}/job-alerts/add-alert`);
  };

  const handleMenuOptions = () => {
    const MENU_OPTIONS = [
      {
        label: "Edit Alert",
        icon: "akar-icons:edit",
        handleClick(data) {
          handleEditAlert(data);
        },
      },
      {
        label: "Delete Alert",
        icon: "ant-design:delete-twotone",
        handleClick: (data) => handleDeleteConfimation(data),
      },
    ];

    return MENU_OPTIONS;
  };

  const handleEditAlert = (data) => {
    navigate(
      `/${source_slug}/${jobtype_slug}/job-alerts/edit-alert/${data._id}`,
      {
        state: { alert: data },
      }
    );
  };

  const handleDeleteConfimation = (value) => {
    setTargetAlert(value);
    setDeleteDialogOpen(true);
  };

  const handleDelete = async () => {
    const resp = await delete_job_alert(targetAlert._id);
    if (resp.code == 200) {
      setAlertsList((prev) =>
        prev.filter((obj) => obj._id !== targetAlert._id)
      );
      enqueueSnackbar(resp.message, { variant: "success" });
    } else {
      enqueueSnackbar(resp.message, { variant: "error" });
    }
    setDeleteDialogOpen(false);
  };

  const handleChangeStatusOfAlert = async () => {
    const postData = {
      status: !targetAlert.status,
    };
    const resp = await change_subscription_of_job_alert(
      targetAlert._id,
      postData
    );
    if (resp.code == 200) {
      setAlertsList((prev) =>
        prev.map((obj) =>
          obj._id == targetAlert._id
            ? { ...obj, status: !obj.status, isloading: false }
            : obj
        )
      );
      enqueueSnackbar(resp.message, { variant: "success" });
    } else {
      enqueueSnackbar(resp.message, { variant: "error" });
    }
    setStatusChangeConfirmation(false);
  };

  const handleGetAlertListing = async () => {
    const resp = await get_job_alerts();
    if (resp.code == 200) {
      let list = resp.data.alert;
      setAlertsList(list);
      if (target_alert) {
        let targetObj = list.find((obj) => obj._id == target_alert);
        console.log(targetObj, "--targetObj");
        if (targetObj && targetObj.status) {
          setTargetAlert(targetObj);
          setStatusChangeConfirmation(true);
          if (location.search) {
            navigate(location.pathname, { replace: true });
          }
        }
      }
    } else {
      enqueueSnackbar(resp.message, { variant: "error" });
    }
    setLoading(false);
  };

  const handleNavigateJobs = (alert) => {
    navigate(
      `/jobs/${jobtype_slug}?search=${encodeURIComponent(
        alert?.job_title || ""
      )}&location=${encodeURIComponent(alert?.location || "")}`,
      {
        state: { backUrl: `/${source_slug}/${jobtype_slug}/job-alerts` },
      }
    );
  };

  useEffect(() => {
    handleGetAlertListing();
    setBreadCrumb([
      {
        name: `Live Job Feed`,
        path: `/${source_slug}/${jobtype_slug}`,
        active: false,
      },
      {
        name: `Job Alerts`,
        path: `/${source_slug}/${jobtype_slug}/job-alerts`,
        active: false,
      },
    ]);
  }, []);
  return (
    <>
      <CustomConfirmation
        open={deleteDialogOpen}
        setOpen={setDeleteDialogOpen}
        title={"Are you sure you want to delete this job alert?"}
        headerHeading={"Delete Alert"}
        handleAgree={() => handleDelete()}
      />
      {statusChangeConfirmation && (
        <CustomConfirmation
          open={statusChangeConfirmation}
          setOpen={setStatusChangeConfirmation}
          title={`Are you sure you want to ${
            targetAlert.status ? "turn off" : "turn on"
          } email notifications for "${`${targetAlert.job_title} in ${targetAlert.location}`}" job alert?`}
          headerHeading={"Email Alert Subscription"}
          handleAgree={() => handleChangeStatusOfAlert()}
        />
      )}

      <div className="container-fluid mt-3">
        <div className="row mt-0">
          <div className="col-12 heading-main d-flex align-items-center justify-content-between">
            <div>
              <h2>Job Alerts</h2>
              <p>
                Customize your job alerts so you never miss a job that matches
                your interests.
              </p>
            </div>
            <div>
              <Tooltip
                title={
                  alertList.length >= 5
                    ? "You can’t add more than five alerts"
                    : ""
                }
                placement="top"
              >
                <span>
                  <button
                    className="btn-contained-sm"
                    onClick={handleNavidateAddAlert}
                    disabled={loading || alertList.length >= 5}
                  >
                    Add Alert
                  </button>
                </span>
              </Tooltip>
            </div>
          </div>

          {loading ? (
            <CircularLoader />
          ) : alertList.length == 0 ? (
            <div className="mt-5 pt-5">
              <RecordNoImage title="No Job Alerts Found" />
            </div>
          ) : (
            <div className="tw-grid tw-grid-cols-1 tw-gap-4 tw-mt-6">
              {alertList.map((alert, index) => (
                <div key={index} className="tw-card hover-disabled tw-p-4">
                  {/* Header */}
                  <div className="tw-flex tw-items-start tw-justify-between">
                    <h6>
                      {alert.job_title} in {alert.location}
                      {/* {alert.frequency_salary
                        ? ` – ${alert.frequency_salary.replace(
                            /_/g,
                            " "
                          )} Salary`
                        : ""} */}
                    </h6>

                    {/* Status Toggle Button */}
                    <div className="d-flex align-items-start">
                      <FormControlLabel
                        control={
                          <Switch
                            checked={alert.status} // true = active, false = inactive
                            onChange={() => {
                              setTargetAlert(alert);
                              setStatusChangeConfirmation(true);
                            }}
                            sx={{
                              padding: "5px 12px 18px 12px",
                              "& .MuiSwitch-switchBase": {
                                paddingTop: "2px",
                              },
                            }}
                          />
                        }
                        className="me-1"
                        // label={alert.status  ? "Active" : "Inactive"}
                      />

                      {handleMenuOptions().length > 0 && (
                        <CustomPopoverSection
                          menu={handleMenuOptions()}
                          data={alert}
                        />
                      )}
                    </div>
                  </div>

                  {/* Frequency */}
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center tw-gap-3">
                      <div className="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-gray-600">
                        <Repeat className="tw-w-4 tw-h-4" />
                        <span className="tw-capitalize">
                          {alert.frequency.replace(/_/g, " ")}
                        </span>
                      </div>

                      {/* First Email Time */}
                      <div className="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-gray-600">
                        <Clock className="tw-w-4 tw-h-4" />
                        <span>
                          {alert.frequency == "twice_a_day"
                            ? "First Email Sent Time:"
                            : "Email Sent Time"}{" "}
                          {convertTimeToServerTimeZone(
                            alert.sent_time,
                            adminSetting?.time_zone,
                            userTimeZone
                          )}
                        </span>
                      </div>

                      {/* Second Email Time */}
                      {alert.frequency == "twice_a_day" &&
                        alert.second_sent_time && (
                          <div className="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-gray-600">
                            <Clock className="tw-w-4 tw-h-4" />
                            <span>
                              Second Email Sent Time:{" "}
                              {convertTimeToServerTimeZone(
                                alert.second_sent_time,
                                adminSetting?.time_zone,
                                userTimeZone
                              )}
                            </span>
                          </div>
                        )}
                    </div>
                    <div className="text-end">
                      <button
                        className="btn-contained-sm"
                        onClick={() => handleNavigateJobs(alert)}
                      >
                        View Jobs
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
